import React from "react";
import styled from "styled-components";
import DropdownList from "@komon/dropdown/list";
import NavbarButton from "@komon/navigation/navbar/button";
import NavbarDropdown from "@komon/navigation/navbar/dropdown";
import { Locale } from "@linkfluence/models/locale";
import { tr } from "@radarly/i18n";

const StyledNavBarButton = styled(NavbarButton)`
  width: 82px;
`;

const getHelpEntries = (locale: Locale) => [
  {
    id: "help",
    url: tr(locale, "MAIN_MENU.ASSISTANCE_URL"),
    label: tr(locale, "MAIN_MENU.RADARLY_HELP"),
  },
  {
    id: "academy",
    url: tr(locale, "MAIN_MENU.LINKFLUENCE_ACADEMY_URL"),
    label: tr(locale, "MAIN_MENU.LINKFLUENCE_ACADEMY"),
  },
  {
    id: "legal",
    url: tr(locale, "MAIN_MENU.LEGAL_TERMS_URL"),
    label: tr(locale, "MAIN_MENU.LEGAL_TERMS"),
  },
  {
    id: "about",
    url: tr(locale, "MAIN_MENU.LINKFLUENCE_ABOUT_URL"),
    label: tr(locale, "MAIN_MENU.LINKFLUENCE_ABOUT"),
  },
];

interface IProps {
  onClickHelp: (entry: string) => void;
  locale: Locale;
}

const NavigationNavbarHelp = ({ onClickHelp, locale }: IProps) => (
  <NavbarDropdown
    pullRight
    toggle={
      <StyledNavBarButton
        glyph="live-help"
        label={tr(locale, "MAIN_MENU.HELP")}
        transparent
      />
    }
    menu={
      <DropdownList
        items={getHelpEntries(locale)}
        onClick={(entry) => onClickHelp(entry.id as string)}
      />
    }
  />
);

export default NavigationNavbarHelp;
